export default __webpack_public_path__ + "static/allpendants-abff6571478fb40a81c26c5c696a27d1.png";